// Prehistoric.js
import React from "react";
import "./EraPage.css"; // Shared styling across all era pages

function Prehistoric() {
  return (
    <div className="era-page">
      {/* Optional Animated or Illustrated Banner */}
      <div className="era-banner prehistoric-banner">
        <h1>🦴 The Dawn of Humanity</h1>
        <p className="era-subtitle">Grade 1 - Prehistoric Times</p>
      </div>

      {/* Overview Section */}
      <section className="prehistoric-overview">
        <h2>🌍 What Was the Prehistoric Era?</h2>
        <p>
          The Prehistoric Era is the time before writing was invented! Early humans hunted animals, gathered berries, and made simple tools from stone. They lived in caves, made fire, and even painted beautiful art on walls.
        </p>
      </section>

      {/* Key Figures or Concepts */}
      <section className="prehistoric-key">
        <h2>🔍 Key People & Discoveries</h2>
        <ul>
          <li>👣 Early humans like *Homo habilis* and *Homo erectus*</li>
          <li>🔥 Discovery of fire</li>
          <li>🎨 Cave paintings (like in Lascaux, France)</li>
          <li>🪨 Invention of stone tools</li>
        </ul>
      </section>

      {/* Comic or Story */}
      <section className="prehistoric-story">
        <h2>📖 Mini Story: “The Day We Discovered Fire”</h2>
        <p><strong>Little Tama</strong> was cold and scared. But when lightning hit a tree, she saw a dancing light. Could she keep it alive? This was the beginning of fire!</p>
      </section>

      {/* Embedded Learning Video */}
      <section className="prehistoric-media">
        <h2>🎥 Watch & Learn</h2>
        <img
  className="prehistoric-illustration"
  src="/images/prehistoric-scene.png" // rename as you like
  alt="Illustration of early humans discovering fire, painting on cave walls, and making stone tools"
  style={{ width: "100%", maxWidth: 500, borderRadius: "1.5rem", margin: "0 auto", boxShadow: "0 4px 24px rgba(0,0,0,0.12)" }}
/>
      </section>

      {/* Quiz or Interactive */}
      <section className="prehistoric-quiz">
        <h2>🧠 Can You Remember?</h2>
        <ol>
          <li>What did early humans use to make tools?</li>
          <li>Where did they paint pictures?</li>
          <li>Why was fire important?</li>
        </ol>
        <p><em>(Answers can be discussed in class or with parents!)</em></p>
      </section>

      {/* Timeline or Visual Aid */}
      <section className="prehistoric-timeline">
        <h2>📅 Timeline of Prehistory</h2>
        <ul>
          <li>~2 million years ago – Early humans appear</li>
          <li>~1.5 million years ago – Fire discovered</li>
          <li>~30,000 years ago – Cave art appears</li>
        </ul>
      </section>
    </div>
  );
}

export default Prehistoric;
